/**
 * Live updates
 */
var State;
(function (State) {
    State[State["Disconnected"] = 0] = "Disconnected";
    State[State["Connecting"] = 1] = "Connecting";
    State[State["Connected"] = 2] = "Connected";
    State[State["Reconnecting"] = 3] = "Reconnecting";
})(State || (State = {}));
export function createLiveChannel() {
    let state = State.Disconnected;
    let subscriptions = {};
    let socket;
    let reconnect = true;
    function connect() {
        const isLocal = ['localhost', '0.0.0.0'].includes(window.location.hostname);
        socket = new WebSocket(isLocal ? 'ws://localhost:8081' : 'wss://gateway.parallel.live');
        socket.onopen = () => {
            state = State.Connected;
            Object.entries(subscriptions).forEach(([channel, { token }]) => socket.send(JSON.stringify({ type: 'subscribe', channel, token })));
        };
        socket.onclose = () => {
            state = reconnect ? State.Reconnecting : State.Disconnected;
            if (!reconnect)
                return;
            setTimeout(() => connect(), 1000);
        };
        socket.onmessage = msg => {
            const content = JSON.parse(msg.data.toString());
            const cb = subscriptions[content.to];
            if (cb)
                cb.callbacks.forEach(cb => {
                    try {
                        cb(content.data);
                    }
                    catch (e) {
                        console.error("Callback error:", e);
                    }
                });
        };
    }
    return {
        // Temporary for demo
        isConnected: () => state === State.Connected,
        subscribe: (channel, token = undefined, callback) => {
            if (subscriptions[channel]) {
                subscriptions[channel].callbacks.push(callback);
            }
            else {
                subscriptions[channel] = {
                    callbacks: [callback],
                    token
                };
                if (state === State.Connected) {
                    socket.send(JSON.stringify({ type: 'subscribe', channel, token }));
                }
                else if (state === State.Disconnected) {
                    connect();
                }
            }
            return () => {
                const sub = subscriptions[channel];
                const callbacks = sub.callbacks;
                if (callbacks.length > 1) {
                    // Remove callback
                    sub.callbacks = sub.callbacks.filter(cb => cb !== callback);
                }
                else if (callbacks.length === 1 && state === State.Connected) {
                    socket.send(JSON.stringify({ type: 'unsubscribe', channel }));
                    delete subscriptions[channel];
                }
            };
        }
    };
}
